export default __webpack_public_path__ + "static/media/assignmentIcon.0eff946f.svg";